import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { useAppSelector, useAppDispatch } from 'app/hooks'
import {
    useParams,
} from 'react-router-dom'
import {
    Button,
    Message,
    Spinner,
    Prompt,
} from 'components'
import {
    showPrompt,
    initializeDefault,
} from 'actions/appActions'
import {
    PromptOptions,
    ErrorMessage,
    PageType,
    CustomEventType,
    RootState,
} from 'app/types'
import { logger } from 'helpers/logger'
import {
    retrieveTemporaryToken,
    resetPassword,
} from 'actions/userActions'
import { createDemoApp } from 'actions/adminActions'

export function DemoView() {
    const { link } = useParams()
    const dispatch = useAppDispatch()
    const loggedIn = useAppSelector((state: RootState) => state.user.loggedIn)
    const error = useAppSelector((state: RootState) => state.user.error)
    const initialized = useAppSelector((state: RootState) => state.app.initialized)
    const [success, setSuccess] = useState(0)

    useEffect(() => {
        // Only create demo app if user is logged in
        if (!loggedIn) {
            return
        }

        const createApp = async () => {
            try {
                // Use the new createDemoApp action that calls our /admin/demo/{link} endpoint
                const result = await dispatch(createDemoApp({ link: link || 'demo' }))
                
                if (result.payload?.app) {
                    setSuccess(1)
                    // Optionally redirect to the new app or show success message
                } else {
                    console.error('Failed to create demo app', result)
                    setSuccess(-1)
                }
            } catch (error) {
                console.error('Error creating demo app:', error)
                setSuccess(-1)
            }
        }
        
        if (link) {
            createApp()
        }
    }, [link, dispatch, loggedIn])

    const handleLogin = () => {
        dispatch(showPrompt(PromptOptions.LoginUser))
    }

    const handleRegister = () => {
        dispatch(showPrompt(PromptOptions.RegisterUser))
    }

    // Show login requirement if user is not logged in
    if (!loggedIn) {
        return <div className="content alt">
            <div className="content-wrapper">
                <Message type="info">
                    <h2>Registration Required</h2>
                    <p>You must be registered to access your demo page. Please log in or register to continue.</p>
                    <div className="button-group" style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
                        <Button style={{margin:0}} onClick={handleLogin}>Log In</Button>
                        <Button style={{margin:0}} secondary onClick={handleRegister}>Register</Button>
                    </div>
                </Message>
            </div>
        </div>
    }

    const spinnerPortal = ReactDOM.createPortal(
        <Spinner className="demo-loading" overlay quotes={false}>
            <h2>Getting things ready</h2>
        </Spinner>,
        document.body
    )

    return <div className="content alt">
        <div className="content-wrapper">
            {success === 0 && spinnerPortal}
            {success === 1 && (
                <Message type="success">
                    <h2>Demo app created successfully!</h2>
                    <p>Your demo application has been created and is ready to use.</p>
                </Message>
            )}
            {success === -1 && (
                <Message type="error">
                    <h2>Failed to create demo app</h2>
                    <p>There was an error creating your demo application. Please try again.</p>
                </Message>
            )}
        </div>
    </div>
}
